import { render, staticRenderFns } from "./AXprogramaversion.vue?vue&type=template&id=2117803d"
import script from "./AXprogramaversion.vue?vue&type=script&lang=js"
export * from "./AXprogramaversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports